export default __webpack_public_path__ + "static/media/messages-gold.bfa50e33.svg";